import { ServiceDefinitionFeeViewModel } from "./serviceDefinitionFeeViewModel";

export class serviceDefinitionDetailsModel {
  constructor() {
    this.serviceDefinitionOutputs = [];
    this.serviceDefinitionFees = [];
    this.serviceDefinitionUserSegments = [];
    this.serviceDefinitionCategories = [];
    this.serviceDefinitionSubCategories = [];
    this.serviceDefinitionChannels = [];
    this.serviceDefinitionLocations = [];
    this.serviceDefinitionAttachments = [];
    this.serviceDefinitionPaymentMethods = [];
    this.serviceDefinitionAvailabilitySlots = [];
  }
  
  id: number;
  identifier: string;
  serviceChannelId: number;
  serviceTypeId: number;
  image: string;
  serviceName: string;
  description: string;
  prerequisites: string;
  policiesProcedures: string;
  termsConditions: string;
  requiredDocuments: string;
  requiredDocumentsListFormConfig: string[]
  sla: string;
  fees: string;  
  readConfigFees: boolean;  
  readConfigSLA: boolean; 
  totalStepsSLA:number; 
  requireRegistration: boolean;
  enableMultipleRequests: boolean;
  isExternal:boolean;
  externalServiceUrl:string;
  isActive: boolean;
  isEligibleToApply: boolean;
  isValidMultipleRequests: boolean;
  isEligibleProfileType: boolean;
  isPermittedToApply: boolean;
  maxRequestsPerApplicant?: number;
  applicantMaxRequestsDurationInDays?: number;
  availabilityStartDate?: any;
  availabilityStartDateCalendar: any;
  availabilityEndDate?: any;
  availabilityEndDateCalendar: any;
  hasCustomApplicantSubmissionFrequency: boolean;
  hasCustomDaysAvailability: boolean;
  isAvailable: boolean;
  serviceDefinitionFees: ServiceDefinitionFeeViewModel[];
  serviceDefinitionOutputs: ServiceDefinitionFeeViewModel[]
  serviceDefinitionUserSegments: number[];
  serviceDefinitionCategories: number[];
  serviceDefinitionSubCategories: number[];
  serviceDefinitionChannels: number[];
  serviceDefinitionLocations: number[];
  serviceDefinitionAttachments: any[];
  serviceDefinitionPaymentMethods: any[];
  serviceDefinitionAvailabilitySlots: any[];
}
